<template>
  <div id="paused" @click.stop="$emit('click')">
    <i
      class="el-icon-video-pause"
      style="font-size: 100px; opacity: 0.2; color: orange"
    ></i>
    <h1 style="font-size: 50px; font-weight: bold">{{ $t("pause.paused") }}</h1>
    <p style="font-size: 22px">{{ $t("pause.continue") }}</p>
  </div>
</template>

<script>
export default {
  name: "Paused",
};
</script>

<style>
#paused {
  width: 100%;
  height: 100%;
  background-color: white;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9792343;
  cursor: pointer;
  flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// src/components/Paused.vue